/**
* @name: table-operation-show
* @author: weiyong
* @date: 2023-07-04 00:06
* @description：table-operation-show
* @update: 2023-07-04 00:06
*/
<template>
  <div class="editable-row-operations">
    <div class="btn-operation editor-cell flex-div">
      <template :key="index" v-for="(btnItem,index) in getShowColumnList">
        <template v-if="index<getMaxBtnLength(column)">
          <btn-base
              v-if="showBtnAclInfo(btnItem,rowIndex)&&showBtnCtl({record, state, btnItem, index})!==false&&btnItem.btnType!=='audioBtn'"
              :elConfig="{props:btnItem}"
              :props="btnItem"
              :btnLabel="getRowButtonLabel(btnItem)"
              :loading-flag="false"
              :disabled="getDisAbledFlag(btnItem)"
              @click.stop="(e)=>{if(getDisAbledFlag(btnItem)){return;};clickItem(e, btnItem, column.list, index);btnClick(record.id,btnItem,record)}"
              :events="[]"
              :styles="{}"
          ></btn-base>
          <audio-btn-base
              v-else-if="showBtnAclInfo(btnItem,rowIndex)&&showBtnCtl({record, state, btnItem, index})!==false&&btnItem.btnType==='audioBtn'"
              :elConfig="{props:btnItem}"
              :props="btnItem"
              :btnLabel="getRowButtonLabel(btnItem)"
              :loading-flag="false"
              :record="record"
              @click.stop="(e)=>{if(getDisAbledFlag(btnItem)){return;};clickItem(e, btnItem, column.list, index);btnClick(record.id,btnItem,record)}"
              :events="[]"
              :styles="{}"
          ></audio-btn-base>
          <div v-if="showBtnCtl({record, state, btnItem, index})!==false" class="btn-line"></div>
        </template>
      </template>

      <template v-if="getShowColumnList.length>getMaxBtnLength(column)">
        <div class="btn-line"></div>
        <a-dropdown>
          <template #overlay>
            <a-menu>
              <template :key="index" v-for="(btnItem,index) in getShowColumnList">
                <template v-if="index>=getMaxBtnLength(column)">
                  <a-menu-item class="menu-btn-li" v-if="showBtnAclInfo(btnItem,rowIndex)&&showBtnCtl({record, state, btnItem, index})!==false">
                    <btn-base
                        :elConfig="{props:btnItem}"
                        :props="btnItem" class="w100b"
                        :btnLabel="getRowButtonLabel(btnItem)"
                        :loading-flag="false"
                        :disabled="getDisAbledFlag(btnItem)"
                        @click.stop="(e)=>{if(getDisAbledFlag(btnItem)){return;};btnClick(record.id,btnItem,record)}"
                        :events="[]"
                        :styles="{}"
                    ></btn-base>
                  </a-menu-item>
                </template>
              </template>
            </a-menu>
          </template>
          <a-button class="more-btn" type="link" size="small">
            <span>更多</span>
            <span><DownOutlined style="font-size:12px;"/></span>
          </a-button>
        </a-dropdown>
      </template>


    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "table-operation-show",
});
</script>

<script lang="ts" setup>
import {Dropdown as ADropdown,Menu as AMenu,MenuItem as AMenuItem,Button as AButton} from 'ant-design-vue';
import {DownOutlined} from "@ant-design/icons-vue";
import AudioBtnBase from "@/main-page/components/audio-btn-base.vue";
import BtnBase from "@/main-page/components/btnBase.vue";
import {defineEmits, defineProps, getCurrentInstance, unref, inject} from "vue";
import {useComEvent} from "@/main-page/ctls/hooks/useComEvent";
import {getStateVuexVal, usePageModelsStore} from "@/store/modules/pageModels";
import {storeToRefs} from "pinia";
import {deepClone} from 'xmgoing-utils';
import {useGridOperationBtnState} from "@/main-page/commonVue/hooks/useGridOperationBtnState";
import GoingUtils from "@/utils/goingUtils";
import {runSingleFlowEditCheck} from "@/main-page/simpleFlow/hooks/useFlowEditCheckHooks";

const ctlAclInfos = inject('ctlAclInfos');
const pageModelsStore: any = usePageModelsStore();
const {state} = storeToRefs(pageModelsStore);
const {clickEventByItem, viewModel} = useComEvent({events: []});
/**
 * 获取显示状态
 * @param btnItem
 */
const getShowState = function (btnItem) {
  if (btnItem['vuex']) {
    return getStateVuexVal(btnItem['vuex'])
  } else {
    return btnItem.ctlType == null || btnItem.ctlType === '' || btnItem.ctlType === 'btn';
  }
}
const props: any = defineProps({
  disabled:{},
  rowIndex:{},
  exportCode: {},
  pageStore: {},
  tableDs:{},
  domainCode: {},
  gridKey: {},
  record: {},
  column: {},
  /** 数据表格 props（含流程可写配置，供操作栏审核节点分流） */
  tableProps: {}
});
const {record, gridKey, exportCode,disabled,column,tableDs} = toRefs(props);

const roleAppConfigs = inject("roleAppConfigs");
//按钮操作状态控制
const {
  getShowColumnList,
  showBtnCtl,
  showBtnAclInfo,
  getDisAbledFlag,
  getRowButtonLabel
} = useGridOperationBtnState({ctlAclInfos,gridKey,record, disabled,state,column, roleAppConfigs});

const emits = defineEmits(['editorChang','cellBtnClick', 'btnClickFun']);

/**
 * 操作栏联查：校验配置与行数据后打开全流程追溯
 */
const handleLinkTraceClick = (row: any) => {
  const col = unref(column) || {};
  if (col.linkTraceDocType == null || col.linkTraceDocType === '') {
    GoingUtils.showWarningMsg('请先在字段明细「联查上下游」中配置单据类型');
    return;
  }
  const idField = (col.linkTraceIdName != null && col.linkTraceIdName !== '') ? col.linkTraceIdName : 'id';
  const codeField = (col.linkTraceCodeName != null && col.linkTraceCodeName !== '') ? col.linkTraceCodeName : 'docNo';
  const id = row?.[idField];
  if (id == null || id === '') {
    GoingUtils.showWarningMsg('当前行缺少单据ID');
    return;
  }
  const docNo = row?.[codeField];
  viewModel.openFullProcessTrace(id, col.linkTraceDocType, docNo);
};

/**
 * 操作栏变更记录：校验领域编码与行主键后打开抽屉
 */
const handleChangeRecordClick = (row: any) => {
  const tableCode = unref(props).domainCode;
  if (tableCode == null || tableCode === '') {
    GoingUtils.showWarningMsg('当前表格未绑定领域对象编码');
    return;
  }
  const col = unref(column) || {};
  const idField = (col.changeRecordIdName != null && col.changeRecordIdName !== '')
    ? col.changeRecordIdName
    : 'id';
  const bizId = row?.[idField];
  if (bizId == null || bizId === '') {
    GoingUtils.showWarningMsg('当前行缺少业务主键');
    return;
  }
  viewModel.openChangeRecord(tableCode, bizId);
};

/**
 * 按钮点击事件
 * @param recordId
 * @param btnItem
 * @param record
 */
const btnClick = async (recordId: string, btnItem: any, record: any) => {
  if (btnItem?.isLinkTraceBtn || btnItem?.value === '__linkTrace') {
    handleLinkTraceClick(record);
    return;
  }
  if (btnItem?.isChangeRecordBtn || btnItem?.value === '__changeRecord') {
    handleChangeRecordClick(record);
    return;
  }
  if (unref(exportCode)) {
    emits('cellBtnClick', {
      gridKey:unref(gridKey),
      rowIndex:unref(props).rowIndex,
      btnItem,
      record: deepClone(record),
      editorRecord: deepClone(record)
    })
    return;
  }
  const gate = await runSingleFlowEditCheck(
    btnItem,
    record,
    viewModel,
    unref(props).tableProps,
    unref(gridKey),
  );
  // openEditor：已打开流程处理页，不再跑按钮原 jsContent
  if (gate === 'abort' || gate === 'openEditor') {
    return;
  }
  if (btnItem && btnItem.jsContent) {
    clickEventByItem({jsContent: btnItem.jsContent}, {
      gridKey:unref(gridKey),
      rowIndex:unref(props).rowIndex,
      record: deepClone(record),
      editorRecord: deepClone(record)
    }, props.pageStore && props.pageStore.viewModel);
  }
  emits('btnClickFun', recordId, btnItem);
}

const getBtnShowFlag = function (btnItem: any) {
  if (btnItem && btnItem.showFlag) {
    if (typeof (btnItem.showFlag) === 'function') {
      return btnItem.showFlag({record: props.record, column: props.column});
    } else {
      return btnItem.showFlag;
    }
  }
  return true;
}

const getRecordKey = (row: any) => row?.id ?? row?.key;

/**
 * 查找记录所在的同级列表（根列表或父节点的 children）
 */
const findSiblingContext = (
  list: any[],
  recordKey: string | number,
  siblingList?: any[]
): { list: any[]; index: number } | null => {
  if (!list?.length || recordKey == null) {
    return null;
  }
  const peers = siblingList ?? list;
  for (let i = 0; i < list.length; i++) {
    const item = list[i];
    const itemKey = getRecordKey(item);
    if (itemKey === recordKey || (itemKey + '') === (recordKey + '')) {
      return {list: peers, index: i};
    }
    if (item.children?.length) {
      const found = findSiblingContext(item.children, recordKey, item.children);
      if (found) {
        return found;
      }
    }
  }
  return null;
};

const moveRecordInSiblingList = (siblingList: any[], index: number, direction: 'up' | 'down') => {
  const targetIndex = direction === 'up' ? index - 1 : index + 1;
  const [moved] = siblingList.splice(index, 1);
  siblingList.splice(targetIndex, 0, moved);
};

const moveRecordRow = (direction: 'up' | 'down') => {
  const ds = unref(tableDs);
  const recordKey = getRecordKey(unref(record));
  const ctx = findSiblingContext(ds, recordKey);
  const siblingList = ctx?.list ?? ds;
  const index = ctx?.index ?? unref(props).rowIndex;

  if (direction === 'up') {
    if (index <= 0) {
      GoingUtils.showWarningMsg("已经到第一行，无法再向上");
      return;
    }
  } else if (index < 0 || index >= siblingList.length - 1) {
    GoingUtils.showWarningMsg("已经到最后一行，无法再向下");
    return;
  }
  moveRecordInSiblingList(siblingList, index, direction);
  emits('editorChang', {});
};

const clickItem = (e, ctlItem, list, index) => {
  if (unref(ctlItem).value === 'topRecord') {
    moveRecordRow('up');
    return;
  }
  if (unref(ctlItem).value === 'downRecord') {
    moveRecordRow('down');
    return;
  }
}
/**
 * 获取按钮显示数量
 * @param col
 */
const getMaxBtnLength = function (col) {
  if (col.showBtns && parseInt(col.showBtns) > 0) {
    return parseInt(col.showBtns)
  }
  return 20;
}
</script>

<style type="text/css" lang="less">
.btn-operation {
  .btn-line {
    width: 1px;
    background-color: #eee;

    &:last-of-type {
      display: none;
    }
  }

}
.menu-btn-li{
  .ant-btn.xmButton {
    display: flex;
    align-items: center;
    justify-content: start;
  }
}
.editor-state-bar {

}
</style>
